import { render, staticRenderFns } from "./NewHcProject.vue?vue&type=template&id=0f0e3210&scoped=true&"
import script from "./NewHcProject.vue?vue&type=script&lang=js&"
export * from "./NewHcProject.vue?vue&type=script&lang=js&"
import style0 from "./NewHcProject.vue?vue&type=style&index=0&id=0f0e3210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0e3210",
  null
  
)

export default component.exports